class EventEmitter {
    constructor() {
        this.listeners = {};
        this.pipes = [];
        this.destroyed = false;
    }

    _checkEvent(name) {
        if ("string" !== typeof name) throw new Error("Invalid event name passed expected string got " + typeof name, name);

        if ("undefined" === typeof this.listeners[name]) this.listeners[name] = [];
    }

    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.listeners = {};
        this.pipes = [];
    }

    /**
     * @param {string} event
     * @param {object} data
     * @returns {boolean}
     */
    emit(event, data = {}) {
        try {
            this._checkEvent(event);
            const me = this;
            let returnValue = true;

            this.listeners[event].forEach(function (fn) {
                try {
                    returnValue = (fn.call(me, data) !== false) && returnValue;
                } catch (e) {
                    console.error("Couldn't call event listener '" + event + "' with data ", data, fn, e);
                    me.lastError = e;
                }
            });
            this.pipes.forEach((emitter) => {
                try {
                    if (emitter instanceof EventEmitter || emitter instanceof EventEmitterStatic || emitter.emit instanceof Function) {
                        returnValue = emitter.emit.apply(emitter, arguments) && returnValue;
                    } else if ("function" === typeof emitter) {
                        returnValue = emitter.apply(emitter, arguments) && returnValue;
                    } else {
                        console.error("Invalid pipe", emitter);
                    }
                } catch (e) {
                    console.error("Couldn't pipe event '" + event + "' with data ", data, emitter, e);
                }
            });
            return returnValue;
        } catch (e) {
            console.error(e);
            console.error("Couldn't emit event '" + event + "' with data ", data);
            return false;
        }
    }

    /**
     * @param {string} events
     * @param {function} fn
     * @returns {EventEmitter}
     */
    off(events, fn = null) {
        events.split(" ").forEach((event) => {
            this._checkEvent(event);
            if (fn === null) {
                this.listeners[event] = [];
            } else {
                this.listeners[event] = this.listeners[event].filter((cur) => cur !== fn);
            }
        });
        return this;
    }

    /**
     *
     * @param {string} events
     * @param {function} fn
     * @param {boolean} singleShot
     * @returns {EventEmitter}
     */
    on(events, fn, singleShot = false) {
        if (singleShot) {
            fn = EventEmitter.single_shot_event(this, events, fn);
        }
        events.split(" ").forEach((event) => {
            this._checkEvent(event);
            this.listeners[event].push(fn);
        });
        return this;
    }

    once(event, fn) {
        return this.on(event, fn, true);
    }

    /**
     * @param {EventEmitter} emitter
     * @returns {EventEmitter}
     */
    pipe(emitter) {
        this.pipes.push(emitter);

        return emitter;
    }

    /**
     * @param {EventEmitter} emitter
     * @param {string} event
     * @param {function} callback
     * @returns {function}
     */
    static single_shot_event(emitter, event, callback) {
        let fn = (data) => {
            emitter.off(event, fn);
            return callback.apply(emitter, [data]);
        };

        return fn;
    }
}

class EventEmitterStatic {

    static _init() {
        if (this.emiter) return;
        this.emiter = new EventEmitter();
    }

    static destroy() {
        this._init();
        this.emiter.destroy.apply(this.emiter, arguments);
    }

    static emit(event, data) {
        this._init();
        return this.emiter.emit.apply(this.emiter, arguments);
    }

    static off(event, fn) {
        this._init();
        this.emiter.off.apply(this.emiter, arguments);
        return this;
    }

    static on(event, fn, singleShot = false) {
        this._init();
        this.emiter.on.apply(this.emiter, arguments);
        return this;
    }

    static pipe(emitter) {
        this._init();
        this.emiter.pipe(emitter);
    }
}


export default EventEmitter;

export { EventEmitter, EventEmitterStatic };